'use strict';

if (typeof Map === 'undefined') {
  window.Map = require('core-js/es/map');
}

if (typeof Set === 'undefined') {
  window.Set = require('core-js/es/set');
}

if (typeof Promise === 'undefined') {
  require('promise/lib/rejection-tracking').enable();
  window.Promise = require('promise/lib/es6-extensions.js');
}

Object.assign = require('object-assign');

if (typeof requestAnimationFrame === 'undefined' || typeof cancelAnimationFrame === 'undefined') {
  require('raf').polyfill();
}
